import Logo from "../assets/img/logo.png";
import Logo2 from "../assets/img/logoGreen.jpeg";

export const constants = [
    {
        websiteName: "Flaco Digital",
        websiteLogo: Logo, 
        mainContent: "Sitio web de Flaco Digital: Creadores del Sistema de Lineas", 
        termsContent: "Conoce todos los términos y condiciones de Flaco Digital",
        URL : "https://flacodigital.com",
        metaTitle: "Flaco Digital", 
        metaImage: Logo2, 
        metaURL: "https://flacodigital.com", 
        metaDescription: "Sitio web de Flaco Digital: Creadores del Sistema de Lineas",
        socialMedia: [
            ['Facebook', 'Sorteos el Flaco', 'https://www.facebook.com/profile.php?id=100079640634651'],
            ['Facebook', 'Rifas el Flaco', 'https://www.facebook.com/Rifaselflaco'],
            ['TikTok', 'Rifas el Flaco', 'https://www.facebook.com/Rifaselflaco']
        ], 
        contactNumbers: [
            ['+526143370080'],
        ], 
        openingHours: [
            ['Lunes - Sábado', '9:00 am - 9:00 pm'],
            ['Domingo', '10:00 am - 9:00 pm']
        ]
    }
]

export const terms = [
    {
       TITULAR : "flacodigital.com", 
       SITIOWEB : "flacodigital.com",
       ESTADO: "Chihuaua, Chihuahua", 
       DESARROLLADOR: "flacodigital.com", 
       CONTACTO: "614 337 0080"
    }
]

export const navLinks = [
    {
        id: "home",
        title: "Inicio"
    },
    {
        id: "pricing",
        title: "Precio"
    },
    {
        id: "contact",
        title: "Contacto"
    }
];

